<template>
  <div>
    <div>
      <el-upload class="upload-demo" action="" drag :auto-upload="false" :show-file-list="false" :on-change='changeUpload'>
        <i class="el-icon-plus" v-show="is_img_suss"></i>
        <img v-if="imageUrl" :src="imageUrl" class="avatar">
      </el-upload>
    </div>
    <el-dialog title="图片剪裁" :visible.sync="dialogVisible" append-to-body>
      <div class="cropper-content">
        <div class="cropper" style="text-align:center">
          <vueCropper ref="cropper" :img="option.img" :outputSize="option.outputSize" :outputType="option.outputType" :info="option.info" :canScale="option.canScale" :autoCrop="option.autoCrop" :autoCropWidth="option.autoCropWidth" :autoCropHeight="option.autoCropHeight" :fixed="option.fixed" :fixedBox="option.fixedBox" :fixedNumber="option.fixedNumber" :centerBox="option.centerBox"></vueCropper>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="finish" :loading="loading">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import Qs from "qs";
import { VueCropper } from "vue-cropper";
import Net_Work from "../apis/network.js";
export default {
  name: "vue-test",
  components: {
    VueCropper
  },
  props: ["imageUrl"],
  data() {
    return {
      is_img_suss: true,
      uploadUrl: "/f/api/v3/upload/base64",
      dialogVisible: false,
      option: {
        img: "",
        info: true,
        outputSize: 0.8,
        outputType: "jpeg",
        canScale: true,
        autoCrop: true,
        autoCropWidth: 100,
        autoCropHeight: 100,
        fixedBox: false,
        fixed: false,
        fixedNumber: [1, 1],
        full: true,
        canMoveBox: true,
        original: false,
        centerBox: true,
        infoTrue: true,
        canMove: true
      },
      picsList: [], //页面显示的数组
      // 防止重复提交
      loading: false,
      fileinfo: {}
    };
  },
  methods: {
    changeUpload(file, fileList) {
      const isJPG =
        file.raw.type === "image/jpeg" || file.raw.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 2;
      if (!isLt5M) {
        this.$message.error("上传文件大小不能超过 2MB!");
        return false;
      }
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG 或者PNG格式!");
        return false;
      }
      let img_src = window.URL.createObjectURL(file.raw);
      this.fileinfo = file;
      this.$nextTick(() => {
        this.option.img = img_src;
        this.dialogVisible = true;
      });
    },
    finish() {
      this.$refs.cropper.getCropData(data => {
        this.loading = true;
        axios
          .post(
            this.uploadUrl /*最新代码位置*/,
            Qs.stringify({
              base64: data
            })
          )
          .then(res => {
            if (res.data.code == 0) {
              this.dialogVisible = false;
              // this.imageUrl = res.data.url;
              this.is_img_suss = false;
              this.loading = false;
              this.$emit("imgChangeUrl", res.data.url);
            } else {
            }
          });
      });
    }
  },
  created() {
    var _this = this;
    var _daclass = localStorage.getItem("dbclass-spa");
    if (!_daclass) {
      this.$router.push("/password-login");
    } else {
      _daclass = JSON.parse(_daclass);
      this.acctoken = _daclass.token.access_token;
    }
    if (this.acctoken === "") {
      this.$router.push("/password-login");
    }
    this.uploadUrl =
      Net_Work.publicApi + this.uploadUrl + "?access_token=" + this.acctoken;
  },
  mounted() {
    if (this.imageUrl) {
      this.is_img_suss = false;
    } else {
      this.is_img_suss = true;
    }
  }
};
</script>
<style lang="less" scoped>
.avatar {
  display: block;
  width: 260px;
  height: 90px;
}

.cropper-content {
  .cropper {
    width: auto;
    height: 300px;
  }
}
</style>
<style scoped>
.el-upload-dragger {
  width: 260px;
  height: 90px;
}

.el-icon-plus {
  line-height: 90px;
  font-size: 28px;
  color: #8c939d;
}
</style>



// WEBPACK FOOTER //
// src/components/ImgCropper.vue